export const createParagraph = (className, text = ``) => {
  const p = document.createElement(`p`);
  p.className = className;
  p.innerHTML = text;

  return p;
};
